<template>
  <v-dialog
    v-model="dialogBesoinTrx"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <Loading :value="loading"></Loading>
    <v-card tile>
      <v-toolbar card dark color="primary">
        <v-toolbar-title>BESOINS VEHICULES POUR DES TRAVAUX</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon dark @click.native="closeDialog()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <!-- TAB Projet -->
      <v-layout row>
        <v-flex sm12 ml-1 mr-1 mt-1>
          <v-card>
            <el-tabs
              v-model="onglet"
              type="border-card"
              @tab-click="handleTabClick(onglet)"
            >
              <el-tab-pane label="Besoins â valider">
                <!-- LISTE besoins travaux a valider-->
                <ListeBesoinTravaux
                  @reloadBesoinValider="loadBesoinVehAvalider()"
                ></ListeBesoinTravaux>
                <!--  LISTE besoins travaux a valider-->
                <br />
              </el-tab-pane>
              <el-tab-pane label="Vehicules affectés à des travaux">
                <VehiculeBesoin
                  :listeBesoinsVeh="listeBesoinsVehValid"
                ></VehiculeBesoin>
              </el-tab-pane>
            </el-tabs>
          </v-card>
        </v-flex>
      </v-layout>
      <!--FIN  TAB Projet -->
    </v-card>
  </v-dialog>
</template>

<script>
import Loading from "@/components/Loading";
import ListeBesoinTravaux from "@/components/besoin/listeBesoinTravaux";
import VehiculeBesoin from "@/components/besoin/VehiculeBesoin";

export default {
  components: { Loading, ListeBesoinTravaux, VehiculeBesoin },
  name: "BesoinTravaux",
  props: {
    show: {
      type: Boolean
    }
  },
  data() {
    return {
      domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
      user: JSON.parse(sessionStorage.getItem("userInfo")),
      dialogBesoinTrx: false,
      loading: false,
      onglet: "0",
      //ONGLET BESOINS TRAVAUX A VALIDER
      listeVehicules: [],
      //ONGLET LISTE VEHICULE AFFECTE
      listeBesoinsVehValid: []
    };
  },
  methods: {
    //ONGE=LET VEHICULE AFFECTE
    loadBesoinVehValider() {
      this.loading = true;
      let url = this.domaine + "besoin/vehicule/valider";
      this.$http.get(url).then(
        response => {
          this.listeBesoinsVehValid = response.body.besoins;
          this.loading = false;
        },
        error => {
          this.loading = false;
          this.$message.error(
            "Echec lors du chargement des vehicules affectés au besoins"
          );
        }
      );
    },
    loadBesoinVehAvalider() {
      this.loading = true;
      let url = this.domaine + "besoin/vehicule";
      this.$http.get(url).then(response => {
        this.listeBesoinsVeh = response.body.besoins;
        this.nbBesoins = response.body.besoins.length;
        this.loading = false;
      });
    },
    handleTabClick(tab) {
      switch (tab) {
        case "0":
          this.loadBesoinVehValider();
          break;
        case "1":
          this.loadBesoinVehValider();
          break;

        default:
          this.loadBesoinVehAvalider();
          break;
      }
    },
    closeDialog() {
      this.listeVehicules.splice(0);
      this.$emit("close");
    }
  },

  watch: {
    show: function(newValue, oldvalue) {
      this.dialogBesoinTrx = newValue;

      if (newValue == true) {
        this.onglet = "0";
        //this.loadListeVehicule()
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/besoin/besoinTravaux.vue